import { browserClient } from '@lub0v/santa-client';

/**
 * Same API client as santa-frontend, same cookie-based auth — the backend does
 * not know or care which frontend is talking to it. Kept free of store imports
 * so it stays usable from anywhere (santa-frontend's equivalent grew a circular
 * dependency on its store in order to raise global modals).
 *
 * An empty base URL keeps every request same-origin: `/api/...` on the site in
 * production, and on the dev server in development, where vite.config.ts proxies
 * it to :8000. Calling :8000 directly would be cross-origin and CORS-blocked.
 */
export const santaClient = browserClient('');
